import * as tslib_1 from "tslib";
import { AfterViewInit, Injector, OnDestroy, } from '@angular/core';
import { ActivatedRoute, Router, } from '@angular/router';
import { AppStateFacade } from '@app-state';
import { Interval, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { FILTER_BUILDER, ODataFilterBuilder, } from '@pages/generics/filter-builder';
import { DEFAULT_TRANSACTION_INTERVALS } from '@pages/shared/chart.config';
import { ModalService, StorageService, } from '@services';
import { UiSnackBarService } from '@uipath/angular/components/ui-snackbar';
import cloneDeep from 'lodash-es/cloneDeep';
import isEqual from 'lodash-es/isEqual';
import { BehaviorSubject, combineLatest, forkJoin, merge, of, ReplaySubject, } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, map, startWith, switchMap, takeUntil, tap, } from 'rxjs/operators';
import { GridComponent, GridPageState, IODataSource, } from './grid.component';
import { STATE_HANDLER, } from './state-handlers';
var ODataGridComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ODataGridComponent, _super);
    function ODataGridComponent(_service, _appState, _translate, _injector, _snack, _modal, _storageService) {
        var _this = _super.call(this) || this;
        _this._service = _service;
        _this._appState = _appState;
        _this._translate = _translate;
        _this._injector = _injector;
        _this._snack = _snack;
        _this._modal = _modal;
        _this._storageService = _storageService;
        _this.Interval = Interval;
        _this._expand$ = new BehaviorSubject([]);
        _this._select$ = new BehaviorSubject([]);
        _this._activeQuery$ = new BehaviorSubject({});
        _this._buildQuery = function (_a) {
            var page = _a.page, sort = _a.sort, searchFilters = _a.searchFilters, filters = _a.filters, expand = _a.expand, select = _a.select;
            return _this._filterBuilder.build(tslib_1.__assign({}, _this._footerState, { pageSize: page.pageSize, pageIndex: page.pageIndex }), tslib_1.__assign({}, _this._grid.sortManager.sort$.value, { direction: sort.direction, field: sort.field }), searchFilters, filters, expand, select, _this._service.mapper);
        };
        _this._router = _this._injector.get(Router);
        _this._filterBuilder = _this._injector.get(FILTER_BUILDER, new ODataFilterBuilder());
        return _this;
    }
    Object.defineProperty(ODataGridComponent.prototype, "intervals", {
        get: function () {
            return DEFAULT_TRANSACTION_INTERVALS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ODataGridComponent.prototype, "_footerState", {
        get: function () {
            return this._grid.footer ?
                this._grid.footer.state :
                this._defaultPage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ODataGridComponent.prototype, "_storageKey", {
        get: function () {
            var buildVersion = this._appState.authConfig.value.serverSettings.build.version;
            var userId = this._appState.user.value.id;
            var gridName = location.pathname;
            var tid = this._appState.user.value.tenancyId || 'host';
            return buildVersion + "-" + userId + "-" + gridName + "-" + tid;
        },
        enumerable: true,
        configurable: true
    });
    ODataGridComponent.prototype.intervalValueFor = function (interval) {
        return DEFAULT_TRANSACTION_INTERVALS.find(function (f) { return f.value === interval; });
    };
    ODataGridComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        _super.prototype.ngAfterViewInit.call(this);
        var stateChange$ = new ReplaySubject(1);
        combineLatest([
            this._pagination$,
            this._grid.sortManager.sort$,
            this._search$,
            this._aggregatedFilters$,
            this._expand$,
            this._select$,
        ])
            .pipe(map(function (_a) {
            var page = _a[0], sort = _a[1], searchFilters = _a[2], filters = _a[3], expand = _a[4], select = _a[5];
            return ({
                page: { pageIndex: page.pageIndex, pageSize: page.pageSize },
                sort: { direction: sort.direction, field: sort.field },
                searchFilters: searchFilters,
                filters: filters,
                expand: expand,
                select: select,
            });
        }), distinctUntilChanged(function (x, y) { return isEqual(x, y); }), tap(function (state) {
            var navigateToFirstPage = _this._currentState != null &&
                (!isEqual(_this._currentState.filters, state.filters) ||
                    !isEqual(_this._currentState.searchFilters, state.searchFilters));
            if (navigateToFirstPage) {
                state.page.pageIndex = 0;
            }
            _this._previousState = cloneDeep(_this._currentState);
            _this._currentState = state;
            stateChange$.next();
        }), takeUntil(this._destroyed$))
            .subscribe();
        var folder$ = this._appState.user.folder.change$
            .pipe(tap(function (_) {
            var filtersToReset = _this._ouDependentFilters();
            _this._grid.columns$.getValue()
                .filter(function (c) { return filtersToReset.indexOf((c.searchableDropdown || c).property) > -1; })
                .forEach(function (c) { return c.refetch = true; });
            var independentFilters = _this._grid.filterManager.filter$
                .getValue()
                .filter(function (c) { return filtersToReset.indexOf(c.property) === -1; });
            _this._grid.filterManager.filter$.next(independentFilters);
        }));
        var refreshTrigger$ = merge(this._grid.refresh, this._refresh$, folder$).pipe(startWith(void 0));
        combineLatest([
            refreshTrigger$,
            this._activeQuery$,
            this._state$,
        ])
            .pipe(debounceTime(50), filter(function (_a) {
            var _trigger = _a[0], _query = _a[1], state = _a[2];
            return state === GridPageState.ready;
        }), tap(function () { return _this.loading$.next(true); }), map(function (_a) {
            var _ = _a[0], query = _a[1];
            return query;
        }), switchMap(function (query) { return _this._service
            .get(query)
            .pipe(catchError(function () {
            _this.loading$.next(false);
            return of({ total: 0, data: [] });
        }), tap(function () { return _this.loading$.next(false); })); }), takeUntil(this._destroyed$))
            .subscribe(function (_a) {
            var data = _a.data, total = _a.total;
            _this.data$.next(data);
            _this.total$.next(total);
        });
        var stateHandler = this._injector.get(STATE_HANDLER, function (api) { return api.stateChange$
            .pipe(takeUntil(api.destroyed$))
            .subscribe(function () { return api.nextQuery(); }); });
        stateHandler({
            appState: this._appState,
            storageService: this._storageService,
            destroyed$: this._destroyed$,
            nextQuery: function () { return _this._activeQuery$.next(_this._buildQuery(_this._currentState)); },
            pageChange: function (p) { return _this._grid.footer && _this._grid.footer.pageChange.next(p); },
            columns: this._grid.columns,
            filterManager: this._grid.filterManager,
            header: this._grid.header,
            pageState: this._footerState,
            sortManager: this._grid.sortManager,
            router: this._router,
            stateChange$: stateChange$,
            storageKey: this._storageKey,
            previousState: function () { return _this._previousState; },
            state: function () { return _this._currentState; },
        });
    };
    ODataGridComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this._activeQuery$.complete();
        this._expand$.complete();
    };
    ODataGridComponent.prototype.resetFilter = function () {
        var _this = this;
        var url = this._router.url.split('?')[0];
        this._storageService.remove(this._storageKey);
        // ensure we redirect to a static safe path
        // if host '/' redirects to '/host/tenants/' which can be the initial route
        var tempRedirect = this._appState.user.loggedInAsHost ? '/host/license' : '/';
        this._router.navigate([tempRedirect]).then(function () { return _this._router.navigate([url], {
            relativeTo: _this._injector.get(ActivatedRoute),
            replaceUrl: true,
        }); });
    };
    ODataGridComponent.prototype.removeItems = function (items) {
        var _this = this;
        var ids = (items || this._grid.selectionManager.selected).map(function (entity) { return entity.id; });
        this._modal.onConfirm(null, function () {
            _this.loading$.next(true);
            var svc = _this._service; // FIXME: unknown?
            var requests = ids.map(function (id) {
                return svc.delete(id)
                    .pipe(catchError(function () { return of(true); }));
            });
            forkJoin(requests)
                .pipe(finalize(function () { return _this.loading$.next(false); }))
                .subscribe(function () { return _this._refresh$.next(); });
        }, function () { }, this._translate.instant('grid_action_delete_message'));
    };
    ODataGridComponent.prototype._ouDependentFilters = function () {
        return [];
    };
    return ODataGridComponent;
}(GridComponent));
export { ODataGridComponent };
